module.exports = __webpack_public_path__ + "static/img/z02.351a07c1.png";